// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html {\n  background: #f5f5f5; }\n\np {\n  margin: 0;\n  padding: 0; }\n\nul {\n  list-style: none;\n  margin: 0;\n  padding: 0; }\n\nol {\n  margin: 0;\n  padding: 0; }\n\n::-webkit-scrollbar {\n  width: 10px;\n  height: 10px; }\n\n::-webkit-scrollbar-track {\n  background: #fff;\n  border-radius: 2px; }\n\n::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 10px; }\n\n::-webkit-scrollbar-thumb:hover {\n  background: #999; }\n", ""]);
// Exports
module.exports = exports;
